export const popularBrands = [
  'Audi',
  'BMW',
  'Citroën',
  'Ford',
  'Hyundai',
  'Kia',
  'Mercedes-Benz',
  'Nissan',
  'Opel',
  'Peugeot',
  'Renault',
  'Seat',
  'Toyota',
  'Volkswagen',
];

export const regionOptions = [
  {
    label: 'Álava',
    value: '&address=Álava%2C España&bounds=43.216819%2C-2.232687%2C42.472936%2C-3.286767',
  },
  {
    label: 'Albacete',
    value:
      '&address=provincia de Albacete%2C España&bounds=39.186276%2C-1.622808%2C38.672175%2C-2.180389',
  },
  {
    label: 'Alicante',
    value: '&address=Alicante%2C España&bounds=38.958637%2C0.331378%2C37.838276%2C-1.094162',
  },
  {
    label: 'Almería',
    value:
      '&address=provincia de Almería%2C España&bounds=37.000014%2C-2.202202%2C36.72011%2C-2.544499',
  },
  {
    label: 'Asturias',
    value: '&address=Asturias%2C España&bounds=43.73676%2C-4.5106%2C42.882543%2C-7.182396',
  },
  {
    label: 'Ávila',
    value:
      '&address=provincia de Ávila%2C España&bounds=41.16425%2C-4.16028%2C40.082449%2C-5.737562',
  },
  {
    label: 'Badajoz',
    value:
      '&address=provincia de Badajoz%2C España&bounds=39.450294%2C-4.64776%2C37.941026%2C-7.335807',
  },
  {
    label: 'Barcelona',
    value:
      '&address=provincia de Barcelona%2C España&bounds=42.323302%2C2.822315%2C41.114747%2C1.360413',
  },
  {
    label: 'Burgos',
    value:
      '&address=provincia de Burgos%2C España&bounds=43.196895%2C-2.517395%2C41.450792%2C-4.335332',
  },
  {
    label: 'Cáceres',
    value:
      '&address=provincia de Cáceres%2C España&bounds=40.486602%2C-4.952513%2C39.031579%2C-7.541642',
  },
  {
    label: 'Cádiz',
    value:
      '&address=provincia de Cádiz%2C España&bounds=37.052445%2C-5.086768%2C35.924896%2C-6.559972',
  },
  {
    label: 'Cantabria',
    value: '&address=Cantabria%2C España&bounds=43.586024%2C-3.144413%2C42.758081%2C-4.851446',
  },
  {
    label: 'Castellón',
    value: '&address=Castellón%2C España&bounds=40.788631%2C0.751282%2C39.679776%2C-0.846297',
  },
  {
    label: 'Ciudad Real',
    value:
      '&address=provincia de Ciudad Real%2C España&bounds=39.576761%2C-2.63789%2C38.342761%2C-5.046948',
  },
  {
    label: 'Córdoba',
    value:
      '&address=Provincia de Córdoba%2C Argentina&bounds=-29.500423%2C-61.770893%2C-35.000135%2C-65.771984',
  },
  {
    label: 'Cuenca',
    value:
      '&address=provincia de Cuenca%2C España&bounds=40.658692%2C-1.142395%2C39.226661%2C-3.170234',
  },
  {
    label: 'Gerona',
    value:
      '&address=provincia de Gerona%2C España&bounds=42.495569%2C3.432072%2C41.588219%2C1.724267',
  },
  {
    label: 'Granada',
    value:
      '&address=provincia de Granada%2C España&bounds=38.084094%2C-2.207669%2C36.613893%2C-4.327617',
  },
  {
    label: 'Guadalajara',
    value:
      '&address=provincia de Guadalajara%2C España&bounds=41.327632%2C-1.535638%2C40.152279%2C-3.541099',
  },
  {
    label: 'Guipúzcoa',
    value: '&address=Guipúzcoa%2C España&bounds=43.461975%2C-1.729397%2C42.895458%2C-2.601465',
  },
  {
    label: 'Huelva',
    value:
      '&address=provincia de Huelva%2C España&bounds=38.207964%2C-6.124296%2C36.781912%2C-7.522706',
  },
  {
    label: 'Huesca',
    value:
      '&address=provincia de Huesca%2C España&bounds=42.924494%2C0.771669%2C41.347805%2C-0.934168',
  },
  {
    label: 'Islas Baleares',
    value: '&address=Islas Baleares%2C España&bounds=40.170794%2C4.424429%2C38.578004%2C1.072382',
  },
  {
    label: 'Jaén',
    value:
      '&address=provincia de Jaén%2C España&bounds=38.532752%2C-2.435466%2C37.378347%2C-4.286737',
  },
  {
    label: 'La Coruña',
    value:
      '&address=provincia de La Coruña%2C España&bounds=43.848521%2C-7.610124%2C42.370573%2C-9.392197',
  },
  {
    label: 'La Rioja',
    value: '&address=La Rioja%2C España&bounds=42.644265%2C-1.679284%2C41.919034%2C-3.134271',
  },
  {
    label: 'Las Palmas',
    value:
      '&address=provincia de Las Palmas%2C España&bounds=29.426434%2C-13.324959%2C27.724506%2C-15.844645',
  },
  {
    label: 'León',
    value:
      '&address=provincia de León%2C España&bounds=43.238632%2C-4.734217%2C42.028936%2C-7.077418',
  },
  {
    label: 'Lérida',
    value:
      '&address=provincia de Lérida%2C España&bounds=42.861375%2C1.855518%2C41.274125%2C0.320621',
  },
  {
    label: 'Lugo',
    value:
      '&address=provincia de Lugo%2C España&bounds=43.840477%2C-6.814889%2C42.325693%2C-8.0001',
  },
  {
    label: 'Madrid',
    value:
      '&address=provincia de Madrid%2C España&bounds=41.165701%2C-3.052983%2C39.884799%2C-4.579006',
  },
  {
    label: 'Málaga',
    value:
      '&address=provincia de Málaga%2C España&bounds=37.282403%2C-3.766063%2C36.236354%2C-5.611777',
  },
  {
    label: 'Murcia',
    value:
      '&address=Región de Murcia%2C España&bounds=38.755085%2C-0.549591%2C37.298847%2C-2.344405',
  },
  {
    label: 'Navarra',
    value: '&address=Navarra%2C España&bounds=43.314811%2C-0.724079%2C41.909573%2C-2.499087',
  },
  {
    label: 'Orense',
    value:
      '&address=provincia de Orense%2C España&bounds=42.578589%2C-6.733954%2C41.807416%2C-8.366708',
  },
  {
    label: 'Palencia',
    value:
      '&address=provincia de Palencia%2C España&bounds=43.061022%2C-3.889624%2C41.758313%2C-5.031893',
  },
  {
    label: 'Pontevedra',
    value:
      '&address=provincia de Pontevedra%2C España&bounds=42.860019%2C-7.861429%2C41.848447%2C-9.048965',
  },

  {
    label: 'Salamanca',
    value:
      '&address=provincia de Salamanca%2C España&bounds=41.294157%2C-5.08984%2C40.238924%2C-6.931626',
  },
  // me and my family we built this whole business. no no! salamanca did! salamanca money! salamanca blood!
  {
    label: 'Segovia',
    value:
      '&address=provincia de Segovia%2C España&bounds=41.586071%2C-3.207352%2C40.633245%2C-4.724561',
  },
  {
    label: 'Sevilla',
    value:
      '&address=provincia de Sevilla%2C España&bounds=38.197417%2C-4.653346%2C36.842192%2C-6.538515',
  },
  {
    label: 'Soria',
    value:
      '&address=provincia de Soria%2C España&bounds=42.146028%2C-1.775367%2C41.056508%2C-3.550436',
  },
  {
    label: 'Tarragona',
    value:
      '&address=provincia de Tarragona%2C España&bounds=41.582583%2C1.653152%2C40.467182%2C0.159181',
  },
  {
    label: 'Teruel',
    value:
      '&address=provincia de Teruel%2C España&bounds=41.354298%2C0.293404%2C39.846778%2C-1.805604',
  },
  {
    label: 'Toledo ',
    value:
      '&address=provincia de Toledo%2C España&bounds=40.31801%2C-2.908233%2C39.258502%2C-5.40611',
  },
  {
    label: 'Valencia',
    value:
      '&address=provincia de Valencia%2C España&bounds=40.210748%2C0.00968%2C38.686554%2C-1.528867',
  },
  {
    label: 'Valladolid',
    value:
      '&address=provincia de Valladolid%2C España&bounds=42.311842%2C-3.980666%2C41.094015%2C-5.520893',
  },
  {
    label: 'Vizcaya ',
    value: '&address=Vizcaya%2C España&bounds=43.526729%2C-2.386395%2C42.982232%2C-3.450141',
  },
  {
    label: 'Zamora',
    value:
      '&address=provincia de Zamora%2C España&bounds=42.254178%2C-5.228873%2C41.117173%2C-7.034043',
  },
  {
    label: 'Zaragoza',
    value:
      '&address=provincia de Zaragoza%2C España&bounds=42.74412%2C0.385966%2C40.936239%2C-2.173671',
  },

  {
    label: 'Ceuta',
    value: '&address=Ceuta%2C España&bounds=35.985935%2C-4.2941%2C35.169629%2C-5.441261',
  },
  {
    label: 'Melilla',
    value: '&address=Melilla%2C España&bounds=36.002426%2C-2.3489%2C35.154742%2C-3.905741',
  },
];
